module.exports = __webpack_public_path__ + "static/media/taobao.4ec91e79.png";